/**
 * Converts valid V1 manipulative answer markup to a valid V2 manipulative answer markup
 */
export function convertManipulativeAnswer(keyArray: string): string {
	// determine if it's a multi-drop draggable answer
	const multiDropAnswer = /\w+:\[/;
	const isMultiDrop = multiDropAnswer.test(keyArray);

	// these have the same answer data so just return it
	if (isMultiDrop) {
		return keyArray;
	}

	keyArray = keyArray.replace('[', '');
	keyArray = keyArray.replace(']', '');

	// Split by comma, but not if the comma is inside nested parentheses or inside double-quoted strings (even when the string contains commas)
	const kvps: string[] = [];
	let current = '';
	let depth = 0;
	let inQuotes = false;

	for (let i = 0; i < keyArray.length; i++) {
		const char = keyArray[i];
		if (char === '"') {
			inQuotes = !inQuotes;
			current += char;
		} else if (char === '(' && !inQuotes) {
			depth++;
			current += char;
		} else if (char === ')' && !inQuotes) {
			depth--;
			current += char;
		} else if (char === ',' && depth === 0 && !inQuotes) {
			kvps.push(current);
			current = '';
		} else {
			current += char;
		}
	}
	if (current) {
		kvps.push(current);
	}

	const answerCount = new Map<string, number>();
	let returnString = '';

	for (const key of kvps) {
		const isKvp = key.includes(':');

		let trimmedKey = key.trim();
		if (!isKvp && answerCount.has(trimmedKey)) {
			const currentCount = answerCount.get(trimmedKey) ?? 0;
			answerCount.set(trimmedKey, currentCount + 1);
		} else if (!isKvp) {
			answerCount.set(trimmedKey, 1);
		} else {
			returnString += `${key},`;
		}
	}

	for (const [key, value] of answerCount.entries()) {
		returnString += `${key}:${value},`;
	}

	// trim the last comma
	returnString = returnString.slice(0, -1);

	return returnString;
}